/* Kotton Bar cart-exit survey.
   Eligibility uses live /cart.js (same cart as the header and drawer).
   Structured events are stored as Klaviyo metrics (company id already on the storefront).
   "Something else" text is stored in Klaviyo as other_text and is not sent to ad platforms. */
(function (root, factory) {
  var api = factory();
  if (typeof module === "object" && module.exports) module.exports = api;
  if (typeof document !== "undefined") boot(api);
})(typeof globalThis !== "undefined" ? globalThis : this, function () {
  var DAY = 24 * 60 * 60 * 1000;
  var REASONS = [
    ["not_ready", "I’m just not ready to buy yet"],
    ["price", "The price is higher than I expected"],
    ["shipping", "Shipping cost or delivery time"],
    ["product_info", "I need more product information"],
    ["new_brand", "I’m not ready to buy from a new brand"],
    ["sizing", "I need to think about sizing or fit"],
    ["other", "Something else"]
  ];

  function isCheckoutPath(pathname) {
    var path = pathname || "";
    return /\/(checkouts?|thank[-_]you)(\/|$)/i.test(path) || /\/orders\//i.test(path);
  }

  function suppressionBlocks(now, record) {
    if (!record) return null;
    if (record.submittedUntil && now < record.submittedUntil) return "submitted";
    if (record.dismissedUntil && now < record.dismissedUntil) return "dismissed";
    return null;
  }

  function evaluate(state) {
    if (!state.enabled) return "disabled";
    if (!state.itemCount || state.itemCount < 1) return "empty_cart";
    if (state.checkoutStarted) return "checkout";
    if (state.pageType === "checkout" || isCheckoutPath(state.pathname)) return "checkout_page";
    if (!state.testMode && state.shownThisSession) return "session";
    if (!state.testMode) {
      var blocked = suppressionBlocks(state.now, state.suppression);
      if (blocked) return blocked;
    }
    if (!state.firstCartAt || state.now - state.firstCartAt < state.minimumDelayMs) return "delay";
    return "eligible";
  }

  function isDesktopTopExit(event) {
    if (!event || typeof event.clientY !== "number") return false;
    if (event.clientY > 20) return false;
    return !(event.relatedTarget || event.toElement);
  }

  function mobileIdleReady(now, lastActivityAt, firstCartAt, inactivityMs, minimumDelayMs) {
    if (!firstCartAt || now - firstCartAt < minimumDelayMs) return false;
    return now - lastActivityAt >= inactivityMs;
  }

  function cartSnapshot(cart) {
    var items = (cart && cart.items) || [];
    return {
      item_count: cart.item_count || 0,
      subtotal: (cart.total_price || 0) / 100,
      currency: cart.currency || "",
      items: items.map(function (item) {
        return {
          product_id: item.product_id,
          variant_id: item.variant_id,
          handle: item.handle,
          quantity: item.quantity,
          title: item.product_title || item.title
        };
      })
    };
  }

  return {
    DAY: DAY,
    REASONS: REASONS,
    isCheckoutPath: isCheckoutPath,
    suppressionBlocks: suppressionBlocks,
    evaluate: evaluate,
    isDesktopTopExit: isDesktopTopExit,
    mobileIdleReady: mobileIdleReady,
    cartSnapshot: cartSnapshot
  };
});

function boot(api) {
  if (window.__kbCartExitSurvey) return;
  window.__kbCartExitSurvey = true;

  var defaults = {
    enabled: true,
    dismissCooldownDays: 7,
    submittedCooldownDays: 30,
    minimumDelayMs: 10000,
    mobileInactivityMs: 75000,
    pageType: "",
    template: ""
  };
  var config = Object.assign(defaults, window.KB_CART_EXIT_SURVEY || {});
  var testMode = false;
  try { testMode = new URLSearchParams(location.search).get("kbces") === "test"; } catch (e) {}
  var MOBILE_GATE_MS = 25000;
  var SUPPRESS_KEY = "kb_ces_suppress_v1";
  var RESPONSE_KEY = "kb_ces_responses_v1";
  var SESSION_SHOWN = "kb_ces_shown";
  var SESSION_CHECKOUT = "kb_ces_checkout";
  var SESSION_FIRST = "kb_ces_first_cart_at";
  var SESSION_ELIGIBLE = "kb_ces_eligible_tracked";

  var cart = null;
  var lastActivityAt = Date.now();
  var idleTimer = null;
  var delayTimer = null;
  var dialog = null;
  var lastFocus = null;
  var open = false;

  function now() { return Date.now(); }

  function readJson(storage, key) {
    try { return JSON.parse(storage.getItem(key) || "null"); } catch (e) { return null; }
  }

  function deviceCategory() {
    return window.matchMedia("(pointer: coarse)").matches || window.matchMedia("(max-width: 749px)").matches
      ? "mobile"
      : "desktop";
  }

  function state() {
    return {
      enabled: config.enabled !== false,
      itemCount: cart ? cart.item_count : 0,
      checkoutStarted: sessionStorage.getItem(SESSION_CHECKOUT) === "1",
      pageType: config.pageType || "",
      pathname: location.pathname,
      shownThisSession: sessionStorage.getItem(SESSION_SHOWN) === "1",
      suppression: readJson(localStorage, SUPPRESS_KEY),
      firstCartAt: Number(sessionStorage.getItem(SESSION_FIRST) || 0),
      now: now(),
      testMode: testMode,
      minimumDelayMs: testMode ? 1500 : (deviceCategory() === "mobile" ? MOBILE_GATE_MS : config.minimumDelayMs)
    };
  }

  function centralProperties(extra) {
    var snap = cart ? api.cartSnapshot(cart) : { item_count: 0, subtotal: 0, currency: "", items: [] };
    var items = snap.items || [];
    var props = {
      timestamp: new Date().toISOString(),
      cart_item_count: snap.item_count,
      cart_subtotal: snap.subtotal,
      currency: snap.currency || "",
      product_handles: items.map(function (item) { return item.handle || ""; }).join(","),
      product_ids: items.map(function (item) { return String(item.product_id || ""); }).join(","),
      variant_ids: items.map(function (item) { return String(item.variant_id || ""); }).join(","),
      quantities: items.map(function (item) { return String(item.quantity || ""); }).join(","),
      page_url: location.href,
      page_type: config.pageType || "",
      device: deviceCategory()
    };
    if (extra && extra.reason) props.reason_code = extra.reason;
    if (extra && extra.reason === "other" && extra.other_text) props.other_text = extra.other_text;
    if (extra && extra.trigger) props.trigger_type = extra.trigger;
    if (testMode) props.is_test = true;
    return props;
  }

  function track(name, extra) {
    var shared = Object.assign({}, extra || {});
    delete shared.other_text;
    var payload = Object.assign({
      page_url: location.href,
      page_type: config.pageType || "",
      referrer: document.referrer || "",
      device: deviceCategory(),
      cart: cart ? api.cartSnapshot(cart) : null
    }, shared);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, payload));
    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === "function") {
      Shopify.analytics.publish(name, payload);
    }
    sendCentral(name, extra);
  }

  function klaviyoCompanyId() {
    if (window.__klKey) return window.__klKey;
    var script = document.querySelector("script[src*='klaviyo.js']");
    var match = script && script.src.match(/company_id=([A-Za-z0-9]+)/);
    return match ? match[1] : "";
  }

  function sendCentral(name, extra) {
    var company = klaviyoCompanyId();
    if (!company) return;
    var props = centralProperties(extra);
    var anon = sessionStorage.getItem("kb_ces_anon");
    if (!anon) {
      anon = "kbces-" + Math.random().toString(36).slice(2) + Date.now().toString(36);
      try { sessionStorage.setItem("kb_ces_anon", anon); } catch (e) { anon = "kbces-anon"; }
    }
    var body = {
      data: {
        type: "event",
        attributes: {
          properties: props,
          time: props.timestamp,
          unique_id: name + ":" + props.timestamp,
          metric: { data: { type: "metric", attributes: { name: name } } },
          profile: { data: { type: "profile", attributes: { anonymous_id: anon } } }
        }
      }
    };
    fetch("https://a.klaviyo.com/client/events/?company_id=" + encodeURIComponent(company), {
      method: "POST",
      headers: {
        "Content-Type": "application/vnd.api+json",
        Accept: "application/vnd.api+json",
        revision: "2024-10-15"
      },
      body: JSON.stringify(body),
      keepalive: true,
      credentials: "omit"
    }).catch(function () {});
  }

  function rememberFirstCart() {
    if (!cart || cart.item_count < 1) {
      sessionStorage.removeItem(SESSION_FIRST);
      return;
    }
    if (!sessionStorage.getItem(SESSION_FIRST)) sessionStorage.setItem(SESSION_FIRST, String(now()));
  }

  function schedule() {
    clearTimeout(delayTimer);
    clearTimeout(idleTimer);
    if (open) return;
    var current = state();
    var verdict = api.evaluate(current);
    if (verdict === "delay" && current.itemCount > 0 && current.firstCartAt) {
      delayTimer = setTimeout(schedule, Math.max(250, current.minimumDelayMs - (now() - current.firstCartAt)));
      return;
    }
    if (verdict !== "eligible") return;
    if (sessionStorage.getItem(SESSION_ELIGIBLE) !== "1") {
      sessionStorage.setItem(SESSION_ELIGIBLE, "1");
      track("cart_exit_survey_eligible");
    }
    if (deviceCategory() === "mobile") {
      idleTimer = setTimeout(function () {
        if (api.mobileIdleReady(now(), lastActivityAt, Number(sessionStorage.getItem(SESSION_FIRST) || 0), config.mobileInactivityMs, config.minimumDelayMs)) {
          show("mobile_idle");
        }
      }, config.mobileInactivityMs);
    }
  }

  function refreshCart() {
    var rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    return fetch(rootPath + "cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (next) {
        if (!next) return;
        cart = next;
        rememberFirstCart();
        if (!cart.item_count && open) close(false);
        schedule();
      })
      .catch(function () {});
  }

  function build() {
    dialog = document.createElement("div");
    dialog.className = "kb-ces";
    dialog.hidden = true;
    dialog.innerHTML =
      '<div class="kb-ces__backdrop" data-kb-ces-dismiss></div>' +
      '<div class="kb-ces__dialog" role="dialog" aria-modal="true" aria-labelledby="kb-ces-title" aria-describedby="kb-ces-help">' +
        '<button class="kb-ces__close" type="button" aria-label="Close" data-kb-ces-dismiss>&times;</button>' +
        '<h2 id="kb-ces-title" class="kb-ces__title">Before you go...</h2>' +
        '<p id="kb-ces-help" class="kb-ces__help">We’re a small business, and your feedback helps us grow.</p>' +
        '<form class="kb-ces__form">' +
          '<fieldset class="kb-ces__fieldset">' +
            '<legend class="kb-ces__question">What’s stopping you from completing your purchase today?</legend>' +
            '<div class="kb-ces__options"></div>' +
          '</fieldset>' +
          '<label class="kb-ces__comment" hidden>Something else' +
            '<textarea name="comment" maxlength="500" placeholder="Tell us more..." aria-label="Tell us more"></textarea>' +
          '</label>' +
          '<p class="kb-ces__error" hidden>Please choose one answer.</p>' +
          '<button class="kb-ces__submit" type="submit">Submit feedback</button>' +
        '</form>' +
        '<p class="kb-ces__thanks" hidden>Thank you — your feedback helps us improve.</p>' +
      '</div>';
    var options = dialog.querySelector(".kb-ces__options");
    api.REASONS.forEach(function (reason) {
      var id = "kb-ces-" + reason[0];
      var label = document.createElement("label");
      label.className = "kb-ces__option";
      label.innerHTML = '<input type="radio" name="kb_ces_reason" value="' + reason[0] + '" id="' + id + '"><span>' + reason[1] + '</span>';
      options.appendChild(label);
    });
    document.body.appendChild(dialog);
    dialog.addEventListener("click", function (event) {
      if (event.target.closest("[data-kb-ces-dismiss]")) dismiss();
    });
    dialog.addEventListener("change", function (event) {
      if (event.target.name !== "kb_ces_reason") return;
      dialog.querySelector(".kb-ces__comment").hidden = event.target.value !== "other";
      dialog.querySelector(".kb-ces__error").hidden = true;
    });
    dialog.querySelector("form").addEventListener("submit", submit);
    document.addEventListener("keydown", onKeydown);
  }

  function focusables() {
    return Array.prototype.slice.call(dialog.querySelectorAll("button, input, textarea")).filter(function (el) {
      return !el.hidden && el.offsetParent !== null || el.type === "radio";
    });
  }

  function onKeydown(event) {
    if (!open) return;
    if (event.key === "Escape") {
      event.preventDefault();
      dismiss();
      return;
    }
    if (event.key !== "Tab") return;
    var items = focusables();
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function show(trigger) {
    if (open || api.evaluate(state()) !== "eligible") return;
    if (!dialog) build();
    if (testMode) {
      var form = dialog.querySelector("form");
      form.hidden = false;
      form.reset();
      dialog.querySelector(".kb-ces__thanks").hidden = true;
      dialog.querySelector(".kb-ces__comment").hidden = true;
      dialog.querySelector(".kb-ces__error").hidden = true;
    }
    lastFocus = document.activeElement;
    dialog.hidden = false;
    open = true;
    if (!testMode) sessionStorage.setItem(SESSION_SHOWN, "1");
    document.body.classList.add("kb-ces-open");
    dialog.querySelector(".kb-ces__close").focus();
    track("cart_exit_survey_impression", { trigger: trigger });
  }

  function close(restore) {
    if (!dialog || !open) return;
    open = false;
    dialog.hidden = true;
    document.body.classList.remove("kb-ces-open");
    if (restore !== false && lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function persist(kind) {
    if (testMode) return;
    var record = readJson(localStorage, SUPPRESS_KEY) || {};
    var until = now() + (kind === "submitted" ? config.submittedCooldownDays : config.dismissCooldownDays) * api.DAY;
    if (kind === "submitted") record.submittedUntil = until;
    else record.dismissedUntil = until;
    localStorage.setItem(SUPPRESS_KEY, JSON.stringify(record));
  }

  function dismiss() {
    if (!open) return;
    persist("dismissed");
    track("cart_exit_survey_dismiss");
    close(true);
  }

  function submit(event) {
    event.preventDefault();
    var selected = dialog.querySelector("input[name='kb_ces_reason']:checked");
    var error = dialog.querySelector(".kb-ces__error");
    if (!selected) {
      error.hidden = false;
      return;
    }
    var comment = dialog.querySelector("textarea").value.trim().slice(0, 500);
    var label = (api.REASONS.filter(function (r) { return r[0] === selected.value; })[0] || [])[1] || selected.value;
    var response = {
      reason: selected.value,
      reason_label: label,
      comment: selected.value === "other" ? comment : "",
      timestamp: new Date().toISOString(),
      cart: api.cartSnapshot(cart || { items: [], item_count: 0, total_price: 0, currency: "" }),
      page_url: location.href,
      page_type: config.pageType || "",
      referrer: document.referrer || "",
      device: deviceCategory()
    };
    var log = readJson(localStorage, RESPONSE_KEY) || [];
    log.push(response);
    localStorage.setItem(RESPONSE_KEY, JSON.stringify(log.slice(-30)));
    persist("submitted");
    var klaviyoExtra = { reason: response.reason };
    if (response.reason === "other" && response.comment) klaviyoExtra.other_text = response.comment;
    track("cart_exit_survey_submit", Object.assign({ comment_present: !!response.comment }, klaviyoExtra));
    dialog.querySelector(".kb-ces__form").hidden = true;
    dialog.querySelector(".kb-ces__thanks").hidden = false;
    track("cart_exit_survey_success", klaviyoExtra);
    dialog.querySelector(".kb-ces__close").focus();
  }

  function onDesktopExit(event) {
    if (deviceCategory() !== "desktop") return;
    if (api.isDesktopTopExit(event)) show("exit_intent");
  }
  document.addEventListener("mouseout", onDesktopExit);
  document.documentElement.addEventListener("mouseleave", onDesktopExit);

  ["pointerdown", "keydown", "scroll", "touchstart"].forEach(function (type) {
    document.addEventListener(type, function () {
      lastActivityAt = now();
      if (deviceCategory() === "mobile" && !open) schedule();
    }, { passive: true, capture: true });
  });

  document.addEventListener("click", function (event) {
    var checkout = event.target.closest && event.target.closest("a[href*='/checkout'], button[name='checkout'], input[name='checkout']");
    if (!checkout) return;
    sessionStorage.setItem(SESSION_CHECKOUT, "1");
    close(false);
  }, true);

  var originalFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var result = originalFetch(input, init);
    try {
      var url = typeof input === "string" ? input : input && input.url;
      if (url && /\/cart\/(add|change|update|clear)/.test(url)) {
        result.then(function (response) { if (response && response.ok) refreshCart(); }).catch(function () {});
      }
    } catch (e) {}
    return result;
  };

  window.addEventListener("CART_ITEM_ADDED", function () { refreshCart(); });
  if (typeof subscribe === "function") {
    subscribe("cart-update", function () { refreshCart(); });
  }

  if (document.body && document.body.classList.contains("shopify-design-mode")) return;
  refreshCart();
}
